import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

/**
 * Gate for authenticated routes. With tokens held in memory only, an
 * unauthenticated visitor (including anyone who just reloaded the page) is sent
 * to /login. The server still enforces authorization on every request — this
 * guard is a UX convenience, not a security boundary.
 */
export function ProtectedRoute(): JSX.Element {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <Outlet />;
}
